import en from '@palette/i18n/locales/en';
import fr from '@palette/i18n/locales/fr';

const resources = {
  en,
  fr,
};

export default resources;
